import { useQuery } from "@tanstack/react-query";
import { CognitoUser, getCognitoUser } from "./auth";

export const useCurrentCognitoUser = () =>
  useQuery<CognitoUser | undefined>(["current-cognito-user"], () =>
    getCognitoUser()
  );
